<div *ngrxLet="params$; let params;"
     class="bg-white border border-blue-40 border-solid"
     [style.width.px]="params?.eGridCell?.clientWidth > tabGroup?._elementRef?.nativeElement?.clientWidth ?
       params?.eGridCell?.clientWidth :
       tabGroup?._elementRef?.nativeElement?.clientWidth"
     [ngClass]="{ 'border-[#D62D1A]': editorFormGroup.invalid && editorFormGroup.touched }"
     cdkTrapFocus>
  <mat-tab-group #tabGroup
                 [disablePagination]="true"
                 class="min-w-fit">
    @for (tabName of tabNames; track tabName;) {
      <mat-tab [label]="tabName">
        <form [formGroup]="editorFormGroup">
          <mat-form-field
              appearance="fill"
              class="textFormField">
            <input
                #textInput
                type="text"
                [placeholder]="getFullNameForFieldID(getLscFieldFromTabName(tabName))"
                matInput
                appGxInput
                [formControlName]="getLscFieldFromTabName(tabName)">

            @if (textInput?.value?.length) {
              <div class="copyIcon"
                   (click)="copyTextInput(textInput)">
                <mat-icon svgIcon="content_copy"></mat-icon>
              </div>
            }
          </mat-form-field>
        </form>
      </mat-tab>
    }

  </mat-tab-group>
</div>


